var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "room-filter" },
    [
      _c("modal", {
        attrs: { variant: "drawer", "custom-footer": "" },
        on: { input: _vm.handleOpenModal, close: _vm.handleCloseModal },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (ref) {
                var activate = ref.activate
                var isActive = ref.isActive
                return [
                  _vm._t("default", null, null, {
                    activate: activate,
                    isActive: isActive,
                    resetAllFilters: _vm.resetAllFilters,
                    totalFiltersSelected: _vm.totalFiltersSelected,
                  }),
                ]
              },
            },
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "room-filter--modal-title" }, [
                    _c("span", [_vm._v(_vm._s(_vm.tc("booking.filters")))]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  _c("div", { staticClass: "form" }, [
                    _vm.showAccessibleFilter
                      ? _c(
                          "div",
                          { staticClass: "room-filter--accessible-room" },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isAccessibleRoom,
                                    expression: "isAccessibleRoom",
                                  },
                                ],
                                attrs: {
                                  "data-field-type": "CheckBoxSet",
                                  id: "accessible_rooms",
                                  name: "accessible_rooms",
                                  type: "checkbox",
                                  "aria-label": _vm.tc(
                                    "booking.showAccessibleRooms"
                                  ),
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.isAccessibleRoom)
                                    ? _vm._i(_vm.isAccessibleRoom, null) > -1
                                    : _vm.isAccessibleRoom,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isAccessibleRoom,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isAccessibleRoom = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isAccessibleRoom = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isAccessibleRoom = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.tc("booking.showAccessibleRooms")
                                  ) +
                                  "\n            "
                              ),
                              _c("span", {
                                staticClass: "icon-wheelchair-black",
                              }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "accordion component" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "accordion-wrapper container",
                          attrs: {
                            "aria-label": "Accordion Control Group Buttons",
                          },
                        },
                        [
                          _vm.filteredBedTypeFacets.length > 0
                            ? _c("accordion-tab", {
                                attrs: { "start-expanded": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var toggleTab = ref.toggleTab
                                        var expanded = ref.expanded
                                        return _c(
                                          "li",
                                          { staticClass: "accordion-item" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "accordion-item-label room-filter--filter-group",
                                                class: expanded
                                                  ? "expanded"
                                                  : "",
                                                attrs: {
                                                  id: "accordion-control-id",
                                                  "aria-controls": "content-id",
                                                  "aria-expanded": expanded
                                                    ? "true"
                                                    : "false",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return toggleTab($event)
                                                  },
                                                  enter: toggleTab,
                                                  keydown: function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "space",
                                                        32,
                                                        $event.key,
                                                        [" ", "Spacebar"]
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    $event.preventDefault()
                                                    return toggleTab($event)
                                                  },
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "room-filter--filter-group-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.tc(
                                                            "booking.bedType"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.selectedBedTypes.length >
                                                  0
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "room-filter--filter-group-reset",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              _vm.selectedBedTypes =
                                                                []
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.tc(
                                                                  "booking.reset"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                                _vm._v(" "),
                                                _vm.selectedBedTypes.length > 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "room-filter--filter-group-status",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.selectedBedTypes
                                                              .length
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "accordion-item-content",
                                                attrs: {
                                                  id: "content-id",
                                                  "aria-hidden": expanded
                                                    ? "false"
                                                    : "true",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "accordion-item-content-wrapper",
                                                  },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "room-filter--filter-group-bed-types",
                                                      },
                                                      _vm._l(
                                                        _vm.filteredBedTypeFacets,
                                                        function (bedType) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: bedType.id,
                                                              staticClass:
                                                                "input checkbox",
                                                              class: {
                                                                "bed-type-hidden":
                                                                  _vm.bedTypeIsHidden(
                                                                    bedType.id
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  class: {
                                                                    disabled:
                                                                      _vm.bedTypeIsDisabled(
                                                                        bedType.id
                                                                      ),
                                                                  },
                                                                  attrs: {
                                                                    for: bedType.id,
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.selectedBedTypes,
                                                                          expression:
                                                                            "selectedBedTypes",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                      "data-field-type":
                                                                        "CheckBoxSet",
                                                                      tabindex:
                                                                        expanded
                                                                          ? "0"
                                                                          : "-1",
                                                                      id: bedType.id,
                                                                      disabled:
                                                                        _vm.bedTypeIsDisabled(
                                                                          bedType.id
                                                                        ),
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        bedType.id,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm.selectedBedTypes
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm.selectedBedTypes,
                                                                              bedType.id
                                                                            ) >
                                                                            -1
                                                                          : _vm.selectedBedTypes,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm.selectedBedTypes,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                bedType.id,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                (_vm.selectedBedTypes =
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  ))
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                (_vm.selectedBedTypes =
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                            }
                                                                          } else {
                                                                            _vm.selectedBedTypes =
                                                                              $$c
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        bedType.title
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1680087274
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filteredHighlights.length > 0
                            ? _c("accordion-tab", {
                                attrs: {
                                  "start-expanded": _vm.expandHighlightSection,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var toggleTab = ref.toggleTab
                                        var expanded = ref.expanded
                                        return _c(
                                          "li",
                                          { staticClass: "accordion-item" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "accordion-item-label room-filter--filter-group",
                                                class: expanded
                                                  ? "expanded"
                                                  : "",
                                                attrs: {
                                                  id: "accordion-control-id",
                                                  "aria-controls": "content-id",
                                                  "aria-expanded": expanded
                                                    ? "true"
                                                    : "false",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return toggleTab($event)
                                                  },
                                                  enter: toggleTab,
                                                  keydown: function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "space",
                                                        32,
                                                        $event.key,
                                                        [" ", "Spacebar"]
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    $event.preventDefault()
                                                    return toggleTab($event)
                                                  },
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "room-filter--filter-group-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.tc(
                                                            "booking.highlights"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.selectedHighlights
                                                    .length > 0
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "room-filter--filter-group-reset",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              _vm.selectedHighlights =
                                                                []
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.tc(
                                                                  "booking.reset"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                                _vm._v(" "),
                                                _vm.selectedHighlights.length >
                                                0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "room-filter--filter-group-status",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .selectedHighlights
                                                              .length
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "accordion-item-content",
                                                attrs: {
                                                  id: "content-id",
                                                  "aria-hidden": expanded
                                                    ? "false"
                                                    : "true",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "accordion-item-content-wrapper",
                                                  },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "room-filter--filter-group-highlights",
                                                      },
                                                      _vm._l(
                                                        _vm.filteredHighlights,
                                                        function (highlight) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: highlight.id,
                                                              staticClass:
                                                                "input checkbox",
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  class: {
                                                                    disabled:
                                                                      _vm.highlightIsDisabled(
                                                                        highlight.id
                                                                      ),
                                                                  },
                                                                  attrs: {
                                                                    for: highlight.id,
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.selectedHighlights,
                                                                          expression:
                                                                            "selectedHighlights",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                      "data-field-type":
                                                                        "CheckBoxSet",
                                                                      tabindex:
                                                                        expanded
                                                                          ? "0"
                                                                          : "-1",
                                                                      id: highlight.id,
                                                                      disabled:
                                                                        _vm.highlightIsDisabled(
                                                                          highlight.id
                                                                        ),
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        highlight.id,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm.selectedHighlights
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm.selectedHighlights,
                                                                              highlight.id
                                                                            ) >
                                                                            -1
                                                                          : _vm.selectedHighlights,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm.selectedHighlights,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                highlight.id,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                (_vm.selectedHighlights =
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  ))
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                (_vm.selectedHighlights =
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                            }
                                                                          } else {
                                                                            _vm.selectedHighlights =
                                                                              $$c
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        highlight.title
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2699090374
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function (ref) {
                var deactivate = ref.deactivate
                return [
                  _c("div", { staticClass: "room-filter--footer" }, [
                    _c("div", { staticClass: "room-filter--footer-results" }, [
                      _c(
                        "div",
                        { staticClass: "room-filter--footer-results-text" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.filteredRooms.length) +
                              " " +
                              _vm._s(_vm.tc("booking.matchingResults")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.hasFilterSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "room-filter--footer-results-reset",
                              on: { click: _vm.resetAllFilters },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.tc("booking.resetAll")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "room-filter--footer-cta" }, [
                      _c("button", { on: { click: deactivate } }, [
                        _vm._v(_vm._s(_vm.tc("booking.apply"))),
                      ]),
                    ]),
                  ]),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }